let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7l0wN")).then(() => parcelRequire('gPonu'));